<template>
  <div style='width: 100%;'>
    <div style="font-weight: bolder; padding:10px"> 
      <span >{{title}}</span>
    </div>
    <el-card class="box-card"  shadow="always">
      <div slot="header" class="clearfix">
        <el-row :gutter="3">
           <el-col :span="20" v-if="type == 'DOCUMENT_AUTH'"> 
             
              <el-select v-model="selectValue" :placeholder="$t('msg.pleaseSelect')" :no-data-text="$t('msg.noDataFound')"  clearable style="display:block;" multiple>
                <el-option-group v-for="group in selectList" :key="group.label" :label="group.label">    
                  <el-option v-for="item in group.options" :key="item.value" :label="item.label"  :value="item.value">
                  </el-option>
                </el-option-group> 
              </el-select>

            </el-col>
            <el-col :span="20" v-else>    
              <el-select v-model="selectValue" :placeholder="$t('msg.pleaseSelect')" :no-data-text="$t('msg.noDataFound')" style="display:block;" multiple>
                <el-option v-for="item in selectList" :key="item.value" :label="item.value" :value="item.value"></el-option>
              </el-select>
            </el-col>
            <el-col :span="3">
              <el-button v-if="type == 'DOCUMENT_AUTH'" type="success" icon="el-icon-plus" @click="clickGroupAdd"></el-button>   
              <el-button v-else type="success" icon="el-icon-plus" @click="clickAdd"></el-button>   
            </el-col>
          </el-row>  
      </div>
      <ul v-if="type == 'DOCUMENT_AUTH'">
        <li v-for="(item, index) in currentSelectedList" :key="index" class="item">
          {{ item.value }} 
          <el-link type="danger" @click="clickGroupDel(item.value, index)"><i class="el-icon-delete" ></i></el-link> 
        </li>
      </ul>

      <ul v-else>
        <li v-for="(item, index) in currentSelectedList" :key="index" class="item">
          {{ item.value }} 
          <el-link type="danger" @click="clickDel(item.value, index)"><i class="el-icon-delete" ></i></el-link> 
        </li>
      </ul>
    </el-card>

  </div>
</template>

<script>
import { apiFindSysValueByCategory, apiFindProductSelected,apiFindDocumentListWithoutVersionLang  } from "../../../utils/api.js";
import authHeader from "../../../services/auth-header";
import CommonUtil from "../../../utils/commonUtil.js";


export default {
  props: {    
    title: {
        type: String
    },
    type:{
        type: String
    },
    custId:{
        type: String
    }
  },
  data() {      
      return {
        selectValue:'',
        currentSelectedList:[],
        selectList:[],
        originalSelectList:[]
      }        
  }, 
  mounted() {        
    if(this.type == 'DOCUMENT_AUTH'){
    
      apiFindDocumentListWithoutVersionLang({ headers: authHeader()}).then((response) => {
        //response.data.forEach((item, index) => {
        //  this.originalSelectList.push({ value: item.value });
          // 
        // });
        // CommonUtil.setGroupSelectItem(response.data, this.selectList);
        CommonUtil.setGroupSelectItem(response.data, this.originalSelectList);
        apiFindProductSelected({ headers: authHeader(), condition:this.custId, condition2:this.type }).then((response) => { 
          this.currentSelectedList = response.data;
          this.initGroupSelectList();
        }).catch((err) => {
          console.log(err);
        });
        
      }).catch((err) => {
        console.log(err);
      });
    }else{
      apiFindSysValueByCategory({ headers: authHeader(), condition:this.type}).then((response) => {
        response.data.forEach((item, index) => {
          this.originalSelectList.push({ value: item.value });
        });
        apiFindProductSelected({ headers: authHeader(), condition:this.custId, condition2:this.type }).then((response) => { 
          this.currentSelectedList = response.data;
          this.initSelectList();
        }).catch((err) => {
          console.log(err);
        });
        
      }).catch((err) => {
        console.log(err);
      });
    }

  },
  watch:{
    currentSelectedList: function(){
       this.$emit('updateSelected', this.currentSelectedList, this.type); 
    } 
  },
  methods: {
    initSelectList(){      
      this.selectList = JSON.parse(JSON.stringify( this.originalSelectList));   //深拷貝
      this.currentSelectedList.forEach((item, index) => {
          this.selectList.forEach((value, i) => {
            if(value.value == item.value){
              this.selectList.splice(i, 1);
              return true;
            }
          });
      });
    },
    clickDel(item, index){
      this.currentSelectedList.splice(index, 1);
      this.initSelectList();
      
    },
    clickAdd(){      
      if(this.selectValue != null && this.selectValue != ''){
        this.selectValue.forEach((item, index) => {                  
          this.currentSelectedList.push({
            value: item
          })         
        });        
        this.selectValue = '';
        this.initSelectList();
      }else{
        return this.$message.warning({message: this.$i18n.t('msg.incompleteInfo'), duration: 800});
      }      
    },
    initGroupSelectList(){     
      this.selectList = JSON.parse(JSON.stringify( this.originalSelectList)); //深拷貝   
      this.currentSelectedList.forEach((item, index) => {
          this.selectList.forEach((main, i) => {
            main.options.forEach((option, j) => {
              if(option.value == item.value){
                var a = this.selectList[i];                
                this.selectList[i].options.splice(j, 1);
                return true;
              }
            });
          });
      });
    },
    clickGroupDel(item, index){  
      this.currentSelectedList.splice(index, 1);
      this.initGroupSelectList();
      
    },
    clickGroupAdd(){   
      debugger
      if(this.selectValue != null && this.selectValue != ''){
        
        this.selectValue.forEach((item, index) => {                  
          this.currentSelectedList.push({
            value: item
          })         
        });

        this.selectValue = '';
        this.initGroupSelectList();
      }else{
        return this.$message.warning({message: this.$i18n.t('msg.incompleteInfo'), duration: 800});
      }      
    },

  }
};
</script>

<style scoped>
  .item {
    margin-bottom: 18px;
  }
</style>
